import { Tooltip } from 'ant-design-vue'
import { defineComponent, h, ref, type CSSProperties } from 'vue'

export default defineComponent({
  name: 'OverflowTooltip',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup(props, { slots }) {
    const isOverflow = ref(false)
    const spanEl = ref<HTMLElement>()

    const textStyle: CSSProperties = {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
    }

    const tooltipInnerStyle: CSSProperties = {
      userSelect: 'text',
      cursor: 'text',
    }

    const checkOverflow = () => {
      isOverflow.value = !!spanEl.value && spanEl.value.scrollWidth > spanEl.value.clientWidth
    }

    return () =>
      h(
        Tooltip,
        {
          title: isOverflow.value ? props.title : undefined,
          overlayInnerStyle: tooltipInnerStyle,
          mouseLeaveDelay: 0.2,
        },
        () =>
          h(
            'span',
            {
              ref: spanEl,
              style: textStyle,
              onMouseenter: checkOverflow,
            },
            slots.default?.()
          )
      )
  },
})
